<div class="app-content content" *ngIf="data">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-body">
        <div id="user-profile">
          <section id="timeline" class="timeline-center timeline-wrapper">
            <div class="text-center">
              <img *ngIf="!data?.imgUrl" src="https://res.cloudinary.com/drtcnv1st/image/upload/v1678230926/Empresa/perfil-emp_an8une.png"
              class="img-fluid rounded-circle width-150 shadow-lg">
              <img *ngIf="data?.imgUrl && (data?.imgUrl != '')" src="https://res.cloudinary.com/drtcnv1st/image/upload/v1677859035/Empresa/{{data.imgUrl}}"
              class="img-fluid rounded-circle width-150 shadow-lg"> 
              <h3 class="page-title text-center text-bold-600">{{ data?.nombreEmpresa }}</h3>
              <h5 class="card-title font-medium-3">{{data?.actividadPrincipal}}</h5>
            </div>    
            <ul class="timeline">
              <li class="timeline-line"></li>
              <li class="timeline-item block">
                <div class="timeline-badge">
                  <a title="" data-context="inverse" data-container="body" class="border-silc" 
                    data-original-title="block highlight"></a>
                </div>
                <div class="timeline-card card border-grey border-lighten-2">
                  <div class="card-header">
                    <div class="text-center">
                      <p class="mt-1"><i class="la la-building font-large-1 blue3"></i></p>
                      <h4 class="card-title font-medium-4">Acerca de la empresa</h4>
                      <br>
                      <p class="text-center font-medium-1">{{ data?.descripcionEmpresa }}</p>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item">
                <div class="timeline-badge">
                  <span class="bg-blue3" data-toggle="tooltip" data-placement="left">
                    <i class="feather ft-message-circle"></i></span>
                </div>
                <div class="timeline-card card border-grey border-lighten-2">
                  <div class="card-content">
                    <div class="card-body">
                      <h2 class="card-title font-medium-4">Información de Contacto</h2>
                      <div class="bs-callout-dark callout-border-left callout-transparent text-left callout-left mt-1 p-1">
                        <p><strong>Correo Electrónico: </strong>{{ data?.correoEmpresa }}</p>
                        <p><strong>Teléfonos: </strong>{{ data?.telefonos }}</p>
                        <br>
                        <br>
                        <p><strong>Responsable: </strong>{{ data?.nombreResponsable }}</p>
                        <p><strong>Teléfono del Responsable: </strong>{{ data?.telefonoResponsable }}</p>
                        <p><strong>Correo del Responsable: </strong>{{ data?.correoResponsable }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item">
                <div class="timeline-badge">
                  <span class="bg-blue2" data-toggle="tooltip" data-placement="right">
                    <i class="feather ft-paperclip"></i></span>
                </div>
                <div class="timeline-card card border-grey border-lighten-2">
                  <div class="card-content">
                      <div class="card-body">
                        <h4 class="card-title font-medium-4">Información General</h4>
                        <div class="bs-callout-dark callout-border-left callout-transparent text-left callout-left mt-1 p-1">
                        <p><strong>Actividad Principal: </strong>{{ data?.actividadPrincipal }}</p>
                        <p><strong>RFC: </strong>{{ data?.rfc }}</p>
                        <p><strong>Tipo: </strong>{{ data?.tipo }}</p>
                        <p><strong>Tamaño: </strong>{{ data?.tamano }}</p>
                        <p><strong>Giro: </strong>{{ data?.giro }}</p>
                        <p><strong>Domicilio Fiscal: </strong>{{ data?.domicilioFiscal }}</p>
                        <p><strong>Código Postal: </strong>{{ data?.cp }}</p>
                      </div>
                      </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item">
                <div class="timeline-badge">
                  <span class="bg-warning">
                    <i class="feather ft-settings"></i></span>
                </div>
                <div class="timeline-card card border-grey border-lighten-2">
                  <div class="card-content">
                    <div class="card-body">
                      <h2 class="card-title font-medium-4">Gestión</h2>
                      <div class="bs-callout-dark callout-border-left callout-transparent text-left callout-left mt-1 p-1">
                        <h3 class="card-title font-medium-2">Validación de publicación de ofertas</h3>
                        <p *ngIf="data?.requerirValidacion"><strong>Estado de validación: </strong>Requiere revisión</p>
                        <p *ngIf="!data?.requerirValidacion"><strong>Estado de validación: </strong>Puede publicar sin revisión</p>
                        <button class="btn btn-block btn-round btn-navy" (click)="updateEstadoValidacionOferta()">Cambiar estado de validación</button>
                        <h3 class="card-title font-medium-2 mt-2">Seguridad</h3>
                        <button class="btn btn-block btn-round btn-success ">Habilitar cambio de contraseña</button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="timeline-item block">
                <div class="timeline-badge">
                  <a title="" data-context="inverse" data-container="body" class="border-silc" 
                    data-original-title="block highlight"></a>
                </div>
                <div class="timeline-card card border-grey border-lighten-2" *ngIf="dataOfertas?.data.length > 0">
                  <div class="card-header">
                    <div class="text-center">
                      <p class="mt-1"><i class="icon-briefcase font-large-1 blue3"></i></p>
                      <h4 class="card-title font-medium-4">Ofertas publicadas</h4>
                      <br>
                      <div class="card collapse-icon accordion-icon-rotate">
                        <div class="card-header bg-blue4">
                          <a data-toggle="collapse" class="card-title white lead"
                            (click)="basicColorBorderCollapse1 = !basicColorBorderCollapse1"
                            [attr.aria-expanded]="!basicColorBorderCollapse1" aria-controls="basicColorBorderCollapse1">
                            <h4 class="text-white card-title font-medium-3">Ofertas publicadas por {{data?.nombreEmpresa}}</h4></a>
                        </div>
                        <div id="basicColorBorderCollapse1" [ngbCollapse]="basicColorBorderCollapse1">
                          <div class="card-content">
                            <div class="card-body border-primary">
                              <form>
                                <div class="row">
                                  <div class="col-md-12">
                                    <div class="form-group">
                                      <div class="card-title">
                                        <div class="table-responsive card-body">
                                        <table class="table table-column table-hover">
                                          <thead class="thead bg-blue1">
                                            <tr>                      
                                              <th scope="col">
                                              <h5 class="text-bold-600">Puesto</h5></th>
                                              <th scope="col">
                                                <h5 class="text-bold-600">Lugar</h5></th>
                                              <th scope="col">
                                                <h5 class="text-bold-600">Área</h5></th>
                                              <th scope="col">
                                                <h5 class="text-bold-600">Especialidad</h5></th>
                                              <th scope="col">
                                                <h5 class="text-bold-600">Detalles</h5></th>
                                              <th scope="col">
                                                <h5 class="text-bold-600">No. Postulantes</h5></th>
                                          </thead>
                                          <tbody *ngFor="let oferta of dataOfertas?.data;">
                                            <tr class="ng-star-inserted" *ngIf="!oferta?.deleted">
                                              <th scope="row">{{ oferta.descripcionPuesto }}</th>
                                              <td scope="row">{{ oferta.lugar }}</td>
                                              <td scope="row">{{ oferta.division }}</td>                       
                                              <td scope="row">{{ oferta.area }}</td>
                                              <td scope="row" class="text-center">
                                                <button type="button" class="btn btn-icon btn-primary mr-1" (click)="openDetailOffer(oferta?.idOferta)"
                                                triggers="hover:click:hover" placement="top"
                                                ngbPopover="Consulta información más detallada acerca de la oferta de trabajo. Entérate del perfil y los conocimientos solicitados, así como las responsabilidades del puesto, entre otros datos."
                                                popoverTitle="Detalles de la Oferta">
                                                  <i class="feather ft-eye"></i>
                                                </button>
                                              </td>
                                              <td scope="row">{{ oferta.postulantes }}</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        <div *ngIf="dataOfertas?.totalPages.length > 1"
                                          class="d-flex justify-content-between p-2">
                                          <div class="col-lg-6 col-md-12">
                                            <nav aria-label="Navegador de páginas">
                                              <ul class="pagination justify-content-star pagination-separate ">
                                                <ngb-pagination 
                                                [(page)]="currentPage" 
                                                [collectionSize]="dataOfertas?.totalRows" 
                                                [pageSize]="dataOfertas?.pageSize" 
                                                (pageChange)="pageChange($event)"
                                                class="d-flex justify-content-start"></ngb-pagination>
                                              </ul>
                                            </nav>              
                                          </div>
                                        </div>   
                                      </div>               
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>         
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </section>
          <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
        </div>
      </div>
    </div>
  </div>